import { useTargetOffer } from '@dai-team/analytics-library'

export function usePersonalizedTargetOffer<T extends Record<string, unknown>>(
  mboxName: string | undefined,
  fallbackProps: T
) {
  return useTargetOffer(mboxName, fallbackProps, true)
}
